import { useState, MouseEvent } from 'react';
import { BrokerDto } from '~js/React/services/generatedApi';
import { officeBrokerGrayScale } from '../../helpers';
import { Helmet, HelmetProvider } from 'react-helmet-async';

interface Props {
  broker: BrokerDto;
  indexNo: number;
}

export const ObjectBrokerItem = ({ broker, indexNo }: Props): JSX.Element => {
  const [isActive, setActive] = useState(false);
  const [x, setX] = useState<string>('');
  const [y, setY] = useState<string>('');
  const [clickEvent, setClickEvent] = useState(false);

  const handleClickLink =
    (x: string, y: string) => (event: MouseEvent<HTMLAnchorElement>) => {
      contactRequest(x, y);
    };
  const contactRequest = (x: string, y: string) => {
    setX(x);
    setY(y);
    setClickEvent(true);
  };
  const handleClick = (item: any) => {
    setActive(!isActive);
  };

  return (
    <>
      {broker?.name != null && (
        <div
          className={`${
            isActive ? 'active-broker' : ''
          } flex justify-between flex-wrap items-center bg-white my-4 rounded-md md:w-1/2 lg:w-full`}
        >
          <div
            className={`${
              isActive ? 'max-h-[138px]' : ''
            } contact-container h-full pr-3 overflow-hidden self-start`}
          >
            <div className="flex overflow-hidden items-stretch h-full">
              <div
                className={`self-center broker-content w-full flex-shrink-0 h-full`}
              >
                <div className="flex overflow-hidden items-center align-center py-0 flex-wrap h-full">
                  <div
                    onClick={(e) => {
                      handleClick(this);
                    }}
                    className={`flex justify-between flex-shrink-0 w-full cursor-pointer h-full items-center`}
                  >
                    {broker?.thumbnail && (
                      <img
                        width="89"
                        height="125"
                        loading={`${indexNo === 0 ? 'eager' : 'lazy'}`}
                        src={broker?.thumbnail}
                        alt={broker?.name}
                        className={`block overflow-hidden bg-cover w-24 h-full filter rounded-bl-md rounded-tl-md object-cover ${
                          officeBrokerGrayScale(broker?.officeName)
                            ? 'grayscale'
                            : ''
                        }`}
                      />
                    )}
                    <div className="w-4/5 pb-1 pt-2">
                      <div className="pl-3 flex items-center justify-between">
                        <div className="">
                          <span className="text-grey300 font-ic text-tiny block">
                            {indexNo === 0
                              ? 'Ansvarig mäklare'
                              : 'Extra kontaktperson'}
                          </span>
                          <h5 className="font-icb text-lg mdplus:text-base xl:text-lg">
                            {broker?.name}
                          </h5>
                          <span className="text-grey300 font-ic text-tiny inline-block leading-4">
                            {broker?.title}
                          </span>
                          {broker?.extraTitle && (
                            <span className="text-grey300 font-ic text-tiny inline-block leading-4">
                              /{broker?.extraTitle}
                            </span>
                          )}
                        </div>
                        <img
                          width="24"
                          height="12"
                          className="ml-2 w-6"
                          src={'/Images/Icons/Arrows/arrow-right-blue700.svg'}
                          alt="Arrow right icon"
                          loading={`${indexNo === 0 ? 'eager' : 'lazy'}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`${
                  isActive ? 'translate-x-1/1-' : ''
                } flex-row flex items-center rounded-md py-2 pl-3 bg-white w-full justify-between flex-shrink-0 transform transition duration-200`}
              >
                <img
                  width="24"
                  height="12"
                  className="cursor-pointer w-6 contact-card-back-img transform rotate-180"
                  src={'/Images/Icons/Arrows/arrow-right-blue700.svg'}
                  loading="lazy"
                  alt="Arrow left icon"
                  onClick={(e) => {
                    handleClick(broker?.name);
                  }}
                />
                <div className="w-full ml-4">
                  <div
                    className="cursor-pointer text-center rounded-md hover-blue-border transition duration-200 border-2 font-icb border-blue700 text-blue700 block w-full mb-2"
                    id="contact-phone"
                  >
                    <a
                      onClick={handleClickLink('Mäklare', 'Telefon')}
                      className="p-2 block"
                      href={`tel:${broker?.phone?.trim()}`}
                    >
                      {broker?.phone}
                    </a>
                  </div>
                  <div
                    className="cursor-pointer hover-darken-blue text-center mt-2 rounded-md bg-blue700 text-white block w-full font-icb"
                    id="contact-email"
                  >
                    <a
                      onClick={handleClickLink('Mäklare', 'Mail')}
                      className="p-2 block"
                      href={`mailto:${broker?.email}`}
                    >
                      Maila {broker?.name}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {clickEvent && x && y && (
            <HelmetProvider>
              <Helmet>
                <script>
                  {`
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'kontakt',
                    'eventInfo': {
                      'kontakt': '${x}',
                      'kontakttyp': '${y}'
                  }
                });
                `}
                </script>
              </Helmet>
            </HelmetProvider>
          )}
        </div>
      )}
    </>
  );
};
